import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VBtn,{attrs:{"depressed":"","color":"secondary","loading":_vm.loading,"disabled":_vm.isNotDeductible},on:{"click":_vm.deduct}},[_vm._v(" "+_vm._s(_vm.$t('Deduct'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }